import { Routes } from '@angular/router';
import { MapPageComponent } from '@features/map/pages/map-page/map-page.component';
import { RouteNetworkDetailComponent } from '@features/map/pages/route-network-detail/route-network-detail.component';
import { translationsGuard } from '@core/guards/translation.guard';

export const routes: Routes = [
  {
    path: '',
    component: MapPageComponent,
    canActivate: [translationsGuard],
    children: [
      {
        path: ':id',
        pathMatch: 'full',
        redirectTo: ':id',
      },
      { path: ':id', component: RouteNetworkDetailComponent },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
